import React, { useState } from "react";

const LoginView = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Email:", email, "Password:", password);
    // Aquí puedes conectar tu lógica de autenticación
  };

  return (
    <div
      className="min-h-screen bg-white flex items-center justify-center px-4"
      style={{ fontFamily: '"Plus Jakarta Sans", "Noto Sans", sans-serif' }}
    >
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-[512px] py-8"
        aria-label="Formulario de inicio de sesión"
      >
        <h2 className="text-[#141414] text-[28px] font-bold text-center pb-3">
          Inicia sesión para comprar
        </h2>

        <div className="flex flex-col gap-4 px-4 py-3">
          <label className="flex flex-col">
            <span className="text-[#141414] text-base font-medium pb-2">
              Correo electrónico
            </span>
            <input
              type="email"
              aria-label="Correo electrónico"
              placeholder="Introduce tu correo"
              className="border border-[#e0e0e0] rounded-lg h-14 px-4 text-[#141414] placeholder-[#757575]"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>

          <label className="flex flex-col">
            <span className="text-[#141414] text-base font-medium pb-2">
              Contraseña
            </span>
            <input
              type="password"
              aria-label="Contraseña"
              placeholder="Introduce tu contraseña"
              className="border border-[#e0e0e0] rounded-lg h-14 px-4 text-[#141414] placeholder-[#757575]"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </label>
        </div>

        <div className="px-4">
          <a href="#" className="text-[#757575] text-sm underline">
            ¿Olvidaste tu contraseña?
          </a>
        </div>

        <div className="flex px-4 py-3">
          <button
            type="submit"
            className="flex flex-1 items-center justify-center rounded-lg h-10 px-4 bg-[#666666] text-white text-sm font-bold"
          >
            Iniciar sesión
          </button>
        </div>


        <p className="text-[#757575] text-sm text-center underline px-4">
          ¿No tienes una cuenta?{" "}
          <a href="#" className="text-[#141414] font-medium">
            Regístrate
          </a>
        </p>
      </form>
    </div>
  );
};

export default LoginView;
